import { useMutation } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { removeAppointmentDeposit } from '../../services/appointments';

interface Params {
  onSuccess?: (
    result: Awaited<ReturnType<typeof removeAppointmentDeposit>>,
  ) => void;
  onError?: (error: string) => void;
}

function useRemoveAppointmentDeposit({ onSuccess, onError }: Params) {
  const { user } = useUser();

  return useMutation({
    mutationFn: async (appointmentId: string) => {
      if (!user?.business?.id) throw new Error('Invalid business');

      const result = await removeAppointmentDeposit(appointmentId);

      return result;
    },
    onSuccess,
    onError,
  });
}

export default useRemoveAppointmentDeposit;
